import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Reveal, MaskLine } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function About() {
  const { t } = useApp();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="pt-32 md:pt-40 pb-24 px-5 md:px-10" data-testid="about-page">
      <Seo title={t.seo.about.title} description={t.seo.about.description} />

      <header className="mb-14 md:mb-20">
        <Reveal><p className="text-xs uppercase tracking-[0.28em] text-muted mb-6">{t.about.eyebrow}</p></Reveal>
        <h1 className="font-display font-light text-[18vw] lg:text-[12rem] leading-[0.8] tracking-tighter" data-testid="about-title">
          <MaskLine delay={0.1}>{t.about.title}</MaskLine>
        </h1>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-7 lg:col-start-4 max-w-2xl space-y-7" data-testid="about-body">
          {t.about.paragraphs.map((p, i) => (
            <Reveal key={i} delay={Math.min(i * 0.05, 0.25)}>
              <p className="text-base md:text-lg font-light leading-relaxed text-ink/85">{p}</p>
            </Reveal>
          ))}

          <Reveal delay={0.1}>
            <p className="font-display text-3xl md:text-4xl leading-snug pt-6" data-testid="about-closing">
              {t.about.closing}
            </p>
          </Reveal>

          <Reveal delay={0.12}>
            <Link
              to="/contact"
              data-testid="about-contact-link"
              className="group inline-flex items-center gap-3 mt-6 bg-ink text-paper px-8 py-4 text-xs uppercase tracking-[0.2em] transition-colors duration-500 hover:bg-accent hover:text-ink"
            >
              {t.about.contactCta}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
